import { defineMessages } from 'react-intl-next';

export default defineMessages({
	ofTotalCount: {
		id: 'paginated-picker.async-select.pagination-details.of-total-count',
		defaultMessage: '{itemsCount} of {totalCount}',
		description: 'Total count of items.',
	},
});
